module.exports = require("@prisma/client");